import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';

export class Inspector implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Inspector';
  public readonly apiRoute: string = CONFIG.apiRoutes.inspectors;

  public inspectorId: string;
  public firstName: string;
  public lastName: string;
  public userName: string;

  public get inspectorName(): string { return `${this.lastName}, ${this.firstName}`; }

  public json(): any {
    return this;
  }

  public loadFromJson(data): void {
    this.inspectorId = data.inspectorId;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.userName = data.userName;
  }
}
